export const getStoreCurrency = (): string => {
  if (typeof window === 'undefined') {
    throw new Error('Window object is not available. This function should only be executed in a browser environment.');
  }
  return window.Shopify?.currency?.active || 'AUD';
};
